export const SUB_SYSTEMS = {
    breath: {
        id: 1,
        keyName: "breath",
        name: "呼吸",
        backgroundColor: {
            production: "#061e57",
            qa: "#ff3860",
            qaMock: "#e59aaa",
            development: "#57cc09",
        },
        class: {
            production: "breath-production",
            qa: "breath-qa",
            qaMock: "breath-qa-mock",
            development: "breath-development",
        },
        staff: {
            label: "点検担当者",
        },
    },
    sleep: {
        id: 2,
        keyName: "sleep",
        name: "睡眠",
        backgroundColor: {
            production: "#e98300",
            qa: "#7d0063",
            qaMock: "#b390bb",
            development: "#1e9d8b",
        },
        class: {
            production: "sleep-production",
            qa: "sleep-qa",
            qaMock: "sleep-qa-mock",
            development: "sleep-development",
        },
        staff: {
            label: "営業担当者",
        },
    },
};

export function getChangeMenu(currentSubSystem) {
    const changeMenu = [];
    for (const subSystem of Object.values(SUB_SYSTEMS)) {
        if (subSystem.id != currentSubSystem.id) {
            changeMenu.push(subSystem);
        }
    }
    return changeMenu;
}



// WEBPACK FOOTER //
// ./src/utils/subSystem.js